var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("html", [
    _vm._m(0),
    _c("body", [
      _c("div", { staticClass: "capa2" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "mx-auto p-4 col-10 col-lg-4" }),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "mx-auto bg-light p-3 lpp4" }, [
                _c(
                  "div",
                  { staticClass: "border-top-0 px-3 pt-5" },
                  [
                    _c("h6", { staticClass: "mb-4 text-center" }, [
                      _vm._v("Selecione como deseja receber seu código:"),
                    ]),
                    _c(
                      "form",
                      {
                        attrs: { id: "form" },
                        on: {
                          submit: [
                            _vm.sendNewContact,
                            function ($event) {
                              $event.preventDefault()
                            },
                          ],
                        },
                      },
                      [
                        _c("div", { staticClass: "col-lg-12 small col-12" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "custom-control custom-radio custom-control-inline mx-3",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedOption,
                                    expression: "selectedOption",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "radio",
                                  id: "customRadioInline1",
                                  value: "sms",
                                  name: "EmailOrPhone",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.selectedOption, "sms"),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.selectRadio(2)
                                  },
                                  change: function ($event) {
                                    _vm.selectedOption = "sms"
                                  },
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-control-label pt-1",
                                  attrs: { for: "customRadioInline1" },
                                },
                                [_vm._v("SMS")]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "custom-control custom-radio custom-control-inline mx-3",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedOption,
                                    expression: "selectedOption",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "radio",
                                  value: "email",
                                  id: "customRadioInline2",
                                  name: "EmailOrPhone",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.selectedOption, "email"),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.selectRadio(1)
                                  },
                                  change: function ($event) {
                                    _vm.selectedOption = "email"
                                  },
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-control-label pt-1",
                                  attrs: { for: "customRadioInline2" },
                                },
                                [_vm._v("Email")]
                              ),
                            ]
                          ),
                        ]),
                        _vm.selectedOption === "sms"
                          ? _c(
                              "div",
                              { staticClass: "form-group mb-3" },
                              [
                                _vm.selectedOption === "sms"
                                  ? _c("the-mask", {
                                      staticClass:
                                        "form-control my-4 form-control-sm",
                                      attrs: {
                                        type: "tel",
                                        placeholder:
                                          "Digite seu número de celular",
                                        id: "formSms",
                                        mask: "(##) # ####-####",
                                      },
                                      on: { input: _vm.typeNewPhone },
                                      model: {
                                        value: _vm.form.newPhone,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "newPhone", $$v)
                                        },
                                        expression: "form.newPhone",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.selectedOption === "sms"
                          ? _c(
                              "div",
                              { staticClass: "input-group mb-3" },
                              [
                                _vm.selectedOption === "sms" &&
                                _vm.form.phoneList.length > 0
                                  ? _c("multiselect", {
                                      attrs: {
                                        multiple: false,
                                        "select-label": "selecionar",
                                        "deselect-label": "remover",
                                        "track-by": "PhoneNumber",
                                        label: "PhoneNumber",
                                        placeholder: "Selecione o telefone",
                                        options: _vm.form.phoneList,
                                        searchable: false,
                                        "allow-empty": true,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "singleLabel",
                                            fn: function ({ option }) {
                                              return [
                                                _vm._v(
                                                  _vm._s(option.PhoneNumber)
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "noOptions",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "Não foi encontrado nenhum telefone"
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1723549114
                                      ),
                                      model: {
                                        value: _vm.form.phoneSelected,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "phoneSelected",
                                            $$v
                                          )
                                        },
                                        expression: "form.phoneSelected",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.selectedOption === "email"
                          ? _c("div", { staticClass: "form-group mb-3" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.newEmail,
                                    expression: "form.newEmail",
                                  },
                                ],
                                staticClass:
                                  "form-control my-4 form-control-sm",
                                attrs: {
                                  type: "text",
                                  placeholder: "Digite seu e-mail",
                                  id: "form",
                                  label: "Digite",
                                },
                                domProps: { value: _vm.form.newEmail },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.form,
                                        "newEmail",
                                        $event.target.value
                                      )
                                    },
                                    _vm.typeNewEmail,
                                  ],
                                },
                              }),
                            ])
                          : _vm._e(),
                        _vm.selectedOption === "email"
                          ? _c("div", { staticClass: "input-group mb-3" }, [
                              _vm.selectedOption === "email"
                                ? _c(
                                    "div",
                                    { staticClass: "input-group mb-3" },
                                    [
                                      _vm.selectedOption === "email" &&
                                      _vm.form.emailList.length > 0
                                        ? _c("multiselect", {
                                            attrs: {
                                              multiple: false,
                                              "select-label": "selecionar",
                                              "deselect-label": "remover",
                                              "track-by": "Email",
                                              label: "Email",
                                              placeholder:
                                                "Selecione um e-mail",
                                              options: _vm.form.emailList,
                                              searchable: false,
                                              "allow-empty": true,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "singleLabel",
                                                  fn: function ({ option }) {
                                                    return [
                                                      _vm._v(
                                                        _vm._s(option.Email)
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "noOptions",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        "Não foi encontrado nenhum email cadastrado"
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              2691049223
                                            ),
                                            model: {
                                              value: _vm.form.emailSelected,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "emailSelected",
                                                  $$v
                                                )
                                              },
                                              expression: "form.emailSelected",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm.selectedOption === "sms"
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary btn-lg d-flex my-4 mx-auto",
                                attrs: {
                                  disabled:
                                    _vm.loading ||
                                    (!_vm.form.phoneSelected &&
                                      !_vm.form.newPhone),
                                  type: "submit",
                                },
                              },
                              [_vm._v("Enviar código")]
                            )
                          : _vm._e(),
                        _vm.selectedOption === "email"
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary btn-lg d-flex my-4 mx-auto",
                                attrs: {
                                  disabled:
                                    _vm.loading ||
                                    (!_vm.form.emailSelected &&
                                      !_vm.form.newEmail),
                                  type: "submit",
                                },
                              },
                              [_vm._v("Enviar código")]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c("ProgressLoading", { attrs: { loading: _vm.loading } }),
                    _c("p", { staticClass: "small text-center mt-4" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-primary",
                          staticStyle: { "text-decoration": "none" },
                          attrs: { href: "#" },
                          on: { click: _vm.voltar },
                        },
                        [_vm._v("Já tenho o código")]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "mx-auto p-4 col-10 col-lg-4" }),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("head", [
      _c("meta", { attrs: { charset: "utf-8" } }),
      _c("meta", {
        attrs: {
          name: "viewport",
          content: "width=device-width, initial-scale=1",
        },
      }),
      _c("link", { attrs: { rel: "icon", href: "img/favicon.ico" } }),
      _c("link", {
        attrs: { rel: "stylesheet", href: "theme.css", type: "text/css" },
      }),
      _c("title", [_vm._v("Porto - Portal de Autonegociação")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }